/**
 * EmbeddedBridge — tells the Compass App shell which page is showing.
 *
 * Mounted by AppShell only in embedded mode (utils/embedded.ts). On every
 * client-side route change it posts `{type:'route', path, title}` to the
 * WebView. The shell uses it to keep its native header title in step and to
 * notice when the SPA has bounced to /login (a dead cookie session) so it can
 * re-run the sign-in hand-off instead of showing the web login page.
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { postToShell } from '../../utils/embedded';

/** Pages set document.title after render; wait a tick so the shell gets the final one. */
export const ROUTE_MESSAGE_DELAY_MS = 50;

export function EmbeddedBridge() {
  const location = useLocation();
  useEffect(() => {
    const id = window.setTimeout(() => {
      postToShell({ type: 'route', path: location.pathname + location.search, title: document.title });
    }, ROUTE_MESSAGE_DELAY_MS);
    return () => window.clearTimeout(id);
  }, [location.pathname, location.search]);
  return null;
}
